module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Thumbtack-77b303eeb49513e138445dbac44e631b.svg";